// A finance drawer before its data: a spinner, or why it could not load with Retry. One shell for the job, person,
// expense and catalog drawers, so each loads and fails the same way. It takes the width of the drawer it stands in for.
import { SpinnerIcon } from "@/components/icons";
import { FinanceDrawer, type FinanceDrawerSize } from "./FinanceDrawer";
import { RetryBlock } from "./RetryBlock";

export interface Pending {
  /** Why the data could not load, beside Retry; null while it loads. */
  failure: string | null;
  retrying: boolean;
  retry: () => void;
}

/** The body while the data is not in, for a modal that keeps its own footer meanwhile. */
export function PendingBody({ failure, retrying, retry }: Pending) {
  if (failure !== null) return <RetryBlock message={failure} retrying={retrying} onRetry={retry} />;
  return (
    <div className="flex justify-center py-6">
      <SpinnerIcon className="w-6 h-6 text-gray-400" />
    </div>
  );
}

export function ModalPending({ title, onClose, size, ...pending }: Pending & { title: string; onClose: () => void; size?: FinanceDrawerSize }) {
  return (
    <FinanceDrawer onClose={onClose} size={size} title={title}>
      <PendingBody {...pending} />
    </FinanceDrawer>
  );
}
